import { MASTER_LOGGED_OUT_ACTION_TYPE } from 'store/auth/actions';

import { COMPANY_PROPERTIES_NEW_ACTION_TYPE } from '../actions';

const initialState = {};

const upsertProperty = (companyProperties, item) => {
  const existing = companyProperties || [];
  const replaced = existing.filter(property => property.propertyName !== item.propertyName);

  return replaced.concat(item);
};

const removeProperty = (companyProperties, propertyName) => {
  const existing = companyProperties || [];

  return existing.reduce((acc, property) => {
    if (property.propertyName !== propertyName) {
      acc.push(property);

      return acc;
    }

    if (property.hasGlobalValue) {
      acc.push({ ...property, propertyValue: null, hasLocalValue: false });
    }

    return acc;
  }, []);
};

const companyPropertiesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COMPANY_PROPERTIES_NEW_ACTION_TYPE.GET_COMPANY_PROPERTIES:
      return { ...state, [payload.companyId]: payload.items };

    case COMPANY_PROPERTIES_NEW_ACTION_TYPE.SAVE_COMPANY_PROPERTY:
      return {
        ...state,
        [payload.companyId]: upsertProperty(state[payload.companyId], payload),
      };

    case COMPANY_PROPERTIES_NEW_ACTION_TYPE.REMOVE_COMPANY_PROPERTY:
      return {
        ...state,
        [payload.companyId]: removeProperty(state[payload.companyId], payload.propertyName),
      };

    // Deliberately NOT reset on RESET_STATE: this slice is session-level company config
    // loaded once at boot (DefaultLayout) and read by routing gates (EnableCrm). Pages
    // dispatch resetStateAction on mount, and DefaultLayout never remounts on client-side
    // navigation, so a reset here would wipe the gates' data with nothing to refetch it.
    // Entries are keyed by companyId, so a company switch re-resolves via its own key —
    // but logout DOES clear it so nothing carries across identities.
    case MASTER_LOGGED_OUT_ACTION_TYPE:
      return initialState;

    default:
      return state;
  }
};

export default companyPropertiesReducer;
